import { axiosInstanceAtom } from '@eih-netbroker/common';
import axios, { AxiosInstance } from 'axios';
import { createContext, useCallback } from 'react';
import { Config } from '../shared/config/config';
import { store } from '../shared/state/store';

export type RestContextProps =
  | undefined
  | {
      getAxiosInstance: () => AxiosInstance;
    };

export const axiosInstance = axios.create({
  baseURL: Config.API.usUrl.baseUrl,
});

store.set(axiosInstanceAtom, {
  fn: () => axiosInstance,
});

export const AxiosInstanceContext = createContext<RestContextProps>(undefined);

export const AxiosInstanceProvider = ({ children }: { children: React.ReactNode }) => {
  const getAxiosInstance = useCallback(() => {
    return axiosInstance;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- execute only once
  }, []);

  return <AxiosInstanceContext.Provider value={{ getAxiosInstance }}>{children}</AxiosInstanceContext.Provider>;
};
